import React from 'react';
import styled from '@emotion/styled';
const Anchor = styled.a `
  display: block;
`;
const ANCHOR_ARIA_LABEL = 'DN_BANNER_IMAGE';
const anchorTagClickHandler = (event) => event.preventDefault();
const AnchorTag = ({ children, url }) => (React.createElement(Anchor, { onClick: anchorTagClickHandler, href: url, target: "_blank", "aria-label": ANCHOR_ARIA_LABEL }, children));
export default AnchorTag;
